const COUNT_FORMAT = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

/** Whole numbers with thousands separators, for wells, rows and grid volumes. */
// `|| 0` keeps a small negative value from printing as "-0".
export const formatCount = (value: number) => COUNT_FORMAT.format(Math.round(value) || 0);
